<div class="modal-header">
	<h5 class="modal-title">{{ errorDetails?.title }}</h5>
</div>

<div class="modal-body d-flex flex-column justify-content-center align-items-center">
	<img
		[src]="errorDetails?.img"
		[alt]="errorDetails?.alt"
		class="error-modal-image"
	/>

	<small class="text-justify px-4">
		<div
			[innerHtml]="htmlDesc"
			ngRouteTransformer
		></div>
	</small>
</div>

<div class="modal-footer justify-content-center">
	<button
		*ngFor="let button of errorDetails?.buttons"
		[ngClass]="button?.buttonClass"
		class="btn btn-primary"
		(click)="onButtonAction(button.buttonAction)"
	>
		{{ button.buttonText }}
	</button>
</div>
